import { render, staticRenderFns } from "./DuplicateRecipe.vue?vue&type=template&id=25b208bf&"
import script from "./DuplicateRecipe.vue?vue&type=script&lang=js&"
export * from "./DuplicateRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports